<a
  *ngIf="route"
  [routerLink]="route || null"
  [attr.class]="class"
  routerLinkActive="current"
  #rla="routerLinkActive"
>
  <ng-container *ngTemplateOutlet="tempOutlet"></ng-container>
  <ng-container *ngIf="routeArrow">
    <img
      *ngIf="rla.isActive"
      class="route-arrow"
      src="/assets/icons/right-chevron-teal.svg"
      alt="Arrow"
    />
    <img
      *ngIf="!rla.isActive"
      class="route-arrow"
      src="/assets/icons/right-chevron.svg"
      alt="Arrow"
    />
  </ng-container>
  <img
    *ngIf="linkArrow"
    class="link-arrow"
    src="/assets/icons/thin-arrow-blue.svg"
    alt="Arrow"
  />
</a>
<a
  *ngIf="!route"
  [href]="linkTarget ? linkTarget : null"
  [attr.target]="linkUrl ? userService.addUserIDToURL(linkUrl) : null"
  [attr.class]="class"
>
  <ng-container *ngTemplateOutlet="tempOutlet"></ng-container>
  <img
    *ngIf="linkArrow"
    class="link-arrow"
    src="/assets/icons/thin-arrow-blue.svg"
    alt="Arrow"
  />
</a>
<ng-template #tempOutlet>
  <ng-content></ng-content>
</ng-template>
